function initBlogOverview($section) {
    const $termList = $section.find('.term-list');
    const $topPicks = $section.find('.top-picks-wrap');
    const $blogItems = $section.find('.blog-items');
    const $loader    = $section.find('.loader');

    if (!$blogItems.length) return;

    const $resultsWrap = $blogItems.find('.results-wrap');
    const $loadMoreBox = $blogItems.find('.load-more-box');
    const $loadMoreBtn = $loadMoreBox.find('.js-blog-load-more');

    // Read initial data attributes
    const excluded = $blogItems.data('excluded') || '';
    const perPageAttr = parseInt($blogItems.data('posts-per-page'), 10);
    const perPage = perPageAttr > 0 ? perPageAttr : 6;

    // Store state in data attrs
    $blogItems.data('current-page', parseInt($blogItems.data('current-page'), 10) || 1);
    $blogItems.data('current-term', parseInt($blogItems.data('current-term'), 10) || 0);

    function setButtonLoading(isLoading) {
        if (!$loadMoreBtn.length) return;

        if (isLoading) {
            $loadMoreBtn.prop('disabled', true).addClass('is-loading');
        } else {
            $loadMoreBtn.prop('disabled', false).removeClass('is-loading');
        }
    }

    function setSectionLoading(isLoading, termId) {
        if (!$loader.length) return;

        if (isLoading) {
            // Hide content while waiting for AJAX
            $topPicks.stop(true, true).hide();
            $blogItems.stop(true, true).hide();
            $loader.show();
            return;
        }

        // Show content only after containers are updated
        $loader.hide();

        $blogItems.show();

        // Show top picks only for "All"
        if (parseInt(termId, 10) === 0) {
            $topPicks.show();
        } else {
            $topPicks.hide();
        }
    }

    function fetchPosts(page, termId, append) {
        // append == true => load more, false => replace list
        setButtonLoading(true);
        setSectionLoading(true, termId);

        let restored = false;

        $.ajax({
            url: myajax.url,
            type: 'POST',
            dataType: 'json',
            data: {
                action: 'blog_overview_load_posts',
                nonce: myajax.nonces.blog_overview,
                page: page,
                term_id: termId,
                exclude: excluded,
                posts_per_page: perPage
            }
        }).done(function (response) {
            if (!response || !response.success) return;

            const data = response.data || {};

            if (append) {
                $resultsWrap.append(data.html || '');
            } else {
                $resultsWrap.html(data.html || '');
            }

            // Update state
            $blogItems.data('current-page', page);
            $blogItems.data('current-term', termId);

            // Show / hide load more
            if (data.has_more) {
                $loadMoreBox.show();
            } else {
                $loadMoreBox.hide();
            }

            // IMPORTANT: show content only after we updated containers
            setSectionLoading(false, termId);
            restored = true;
        }).always(function () {
            setButtonLoading(false);

            // If request failed / response invalid, don't keep loader forever
            if (!restored) {
                setSectionLoading(false, termId);
            }
        });
    }

    // Category click handler
    $termList.on('click', '.item', function (e) {
        e.preventDefault();

        const $item = $(this);

        if ($item.hasClass('active')) return;

        $termList.find('.item').removeClass('active');
        $item.addClass('active');

        const termId = parseInt($item.data('id'), 10) || 0;

        // Reset page and load posts for this category
        fetchPosts(1, termId, false);
    });

    // Load more handler
    $loadMoreBtn.on('click', function (e) {
        e.preventDefault();

        const currentPage = parseInt($blogItems.data('current-page'), 10) || 1;
        const termId = parseInt($blogItems.data('current-term'), 10) || 0;

        fetchPosts(currentPage + 1, termId, true);
    });
}

$(document).ready(function () {
    $('.section-blog-overview').each(function () {
        initBlogOverview($(this));
    });
});
